import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule, Location } from "@angular/common";
import { AuthService } from "../../shared/services/auth.service";
import { SharedService } from "../../shared/services/shared.service";
import { Tab } from "src/app/shared/models/tab.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { RXForm } from "src/app/shared/models/order.model";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { Clinic } from "src/app/shared/models/clinic.model";
import { Store } from "@ngrx/store";
import {
  clinicList,
  dashboardData,
  ui_direction,
  ui_mobileNavOpen,
  ui_navigation,
} from "src/app/shared/ngrx/ngrx-selectors";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import {
  GET_AGENTS_LIST,
  GET_CHAT_TASK_STATUS_LIST,
  GET_CLINIC_LIST,
  GET_DASHBOARD_DATA,
  GET_KPI_CONFIG,
  GET_ROLE_LIST,
  GET_RX_OPT,
  GET_SUPPLY_TYPES_LIST,
  GET_TECHINICIANS_LIST,
  GET_TECH_ISSUES_LIST,
  SELECT_INBOX_ORDER,
  SELECT_RX_FORM,
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
  UI__TOGGLE_MOBILE_NAV,
} from "src/app/shared/ngrx/ngrx-actions";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";

@Component({
  selector: "sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    ModalPopupComponent,
  ],
  standalone: true,
})
export class SidebarComponent implements OnInit {
  $el: any;
  config: any;
  location: Location;
  navList: Tab[];
  isSidebarOpen: boolean = true;
  clinicListLoaded: boolean;
  supplyListLoaded: boolean;
  roleListLoaded: boolean;
  agentListLoaded: boolean;
  rxOptLoaded: boolean;
  taskStatusListLoaded: boolean;
  techIssuesListLoaded: boolean;
  techniciansListLoaded: boolean;
  kpiConfigLoaded: boolean;
  version: string;
  allowedInbox: boolean = false;
  allowedDashboard: boolean = false;
  allowedReports: boolean = false;
  allowedSupplies: boolean = false;
  allowedUsers: boolean = false;
  allowedoperationReports: boolean = false;
  allowedLabKpi: boolean = false;
  allowedAgentTasks: boolean = false;
  allowedNotesCatalog: boolean = false;
  allowCreateOrder: boolean = false;
  allowedDeliveryWaybills: boolean = false;
  routeEnum: RouteEnum = new RouteEnum();
  selectClinicDisplay: boolean = false;
  selectedClinic: Clinic;
  destroy$ = new Subject();

  get clinicList(): Clinic[] {
    return this.store.selectSignal(clinicList)();
  }

  get isMobileNavOpen(): boolean {
    return this.store.selectSignal(ui_mobileNavOpen)();
  }

  get dir(): string {
    return this.store.selectSignal(ui_direction)();
  }

  constructor(
    private router: Router,
    private readonly store: Store,
    location: Location,
    private authService: AuthService,
    private sharedService: SharedService,
    private broshService: BroshService,
    private actions$: Actions
  ) {
    this.location = location;
    this.version = this.authService.version;
    console.log(this.version);
  }

  ngOnInit(): void {
    this.allowedInbox = true;
    this.allowedDashboard = true;
    this.allowCreateOrder = this.authService.currentUser.allowCreateOrderSw;

    this.allowedLabKpi =
      this.authService.currentUser.authDetails.getBooleanValue(
        "LAB_KPI.ALLOWED_SW"
      );

    this.allowedDeliveryWaybills =
      this.authService.currentUser.authDetails.getBooleanValue(
        "DISTRIBUTION.CREATE_WAYBILL_SW"
      );

    this.allowedReports =
      this.authService.currentUser.authDetails.getBooleanValue(
        "INVOICES.VIEW_INVOICES_SW"
      );
    this.allowedSupplies =
      this.authService.currentUser.authDetails.getBooleanValue(
        "DELIVERY.REQUEST_DELIVERY_SW"
      ) ||
      this.authService.currentUser.authDetails.getBooleanValue(
        "DELIVERY.APPROVE_DELIVERY_SW"
      );

    this.allowedUsers =
      this.authService.currentUser.authDetails.getBooleanValue(
        "USERS_SCR.ALLOWED_SW"
      );

    this.allowedoperationReports =
      this.authService.currentUser.authDetails.getBooleanValue(
        "OPERATION_REPORTS.ALLOWED_SW"
      );

    this.allowedAgentTasks =
      this.authService.currentUser.authDetails.getBooleanValue(
        "GENERAL_TASKS.ALLOWED_SW"
      );

    this.allowedNotesCatalog =
      this.authService.currentUser.authDetails.getBooleanValue(
        "PRESET_NOTES_BANK.ALLOWED_SW"
      );

    this.sharedService.menuBtnClicked$.subscribe((data) => {
      this.isSidebarOpen = data;
    });

    this.initMenu();

    this.actions$
      .pipe(
        ofType(GET_CLINIC_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.clinicListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_AGENTS_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.agentListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_SUPPLY_TYPES_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.supplyListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_ROLE_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.roleListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_CHAT_TASK_STATUS_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.taskStatusListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_RX_OPT),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.rxOptLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_TECHINICIANS_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.techniciansListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_TECH_ISSUES_LIST),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.techIssuesListLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_KPI_CONFIG),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.kpiConfigLoaded = true;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(GET_DASHBOARD_DATA),
        takeUntil(this.destroy$),
        map(({ }) => {
          let tab = this.navList.find((t) => t.tabId == "notes-catalog");
          if (tab)
            tab.badge =
              this.store.selectSignal(dashboardData)()?.pendingPresetNotesCnt;
          let tab2 = this.navList.find((t) => t.tabId == "agent-tasks");
          if (tab2)
            tab2.badge =
              this.store.selectSignal(dashboardData)()?.generalTasksCnt;
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(UI__SIDEBAR_ROUTE_NAVIGATION),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.navList.forEach(
            (_tb) =>
            (_tb.isActive =
              _tb.tabId === this.store.selectSignal(ui_navigation)().tabId)
          );
        })
      )
      .subscribe();
  }

  initMenu() {
    this.navList = [
      {
        tabId: "dashboard",
        icon: "columns",
        tabTitle: "translate.sidebar.dashboard",
        link: this.sharedService.routeEnum.URL_DASHBOARD,
        isHidden: !this.allowedDashboard,
        img: "assets\\img\\Dashboard.svg",
      },
      {
        tabId: "inbox",
        icon: "list",
        tabTitle: "translate.sidebar.inbox",
        link: this.sharedService.routeEnum.URL_INBOX,
        isHidden: !this.allowedInbox,
        img: "assets\\img\\Inbox.svg",
      },
      {
        tabId: "reports",
        icon: "chart-bar",
        tabTitle: "translate.sidebar.reports",
        link: this.sharedService.routeEnum.URL_REPORTS,
        isHidden: !this.allowedReports,
        img: "assets\\img\\Financial_Reports.svg",
      },
      {
        tabId: "supplies",
        icon: "box",
        tabTitle: "translate.sidebar.supplies",
        link: this.sharedService.routeEnum.URL_SUPPLIES,
        isHidden: !this.allowedSupplies,
        img: "assets\\img\\Packaging.svg",
      },
      {
        tabId: "agent-tasks",
        img: "assets\\img\\Field_Tasks.svg",
        tabTitle: "translate.agentTasks.sidebar",
        link: this.sharedService.routeEnum.URL_AGENT_TASKS,
        isHidden: !this.allowedAgentTasks,
        badge: this.store.selectSignal(dashboardData)()?.generalTasksCnt,
      }, {
        tabId: "delivery-waybills",
        img: "assets\\img\\Packaging.svg",
        tabTitle: "translate.sidebar.deliveryWaybills", //TODO 
        link: this.sharedService.routeEnum.URL_DELIVERY_WAYBILLS,
        isHidden: !this.allowedDeliveryWaybills,
      },
      {
        tabId: "kpi",
        img: "assets\\img\\Analytics.svg",
        tabTitle: "translate.sidebar.kpi",
        link: this.sharedService.routeEnum.URL_KPI,
        isHidden: !this.allowedLabKpi,
      },
      // {
      //   tabId: "operation-reports",
      //   img: "assets\\img\\Operating_reports.svg",
      //   tabTitle: "translate.sidebar.operationReports",
      //   link: this.sharedService.routeEnum.URL_operation_REPORTS,
      //   isHidden: !this.allowedoperationReports,
      // },
      {
        tabId: "mng",
        img: "assets\\img\\System.svg",
        tabTitle: "translate.sidebar.users",
        link: this.sharedService.routeEnum.URL_MNG,
        isHidden: !this.allowedUsers,
      },
      {
        tabId: "notes-catalog",
        img: "assets\\img\\notes_bank.svg",
        tabTitle: "translate.sidebar.notesCatalog",
        link: this.sharedService.routeEnum.URL_NOTES_CATALOG,
        isHidden: !this.allowedNotesCatalog,
        badge: this.store.selectSignal(dashboardData)()?.pendingPresetNotesCnt,
      },

    ];
  }

  ngAfterContentInit() {
    this.navigate(this.navList[0]);
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  isEnabled(tab: Tab): boolean {
    if (tab.tabId == "reports") {
      if (!this.clinicListLoaded) return false;
    }
    if (tab.tabId == "supplies") {
      if (!this.clinicListLoaded || !this.supplyListLoaded) return false;
    }
    if (tab.tabId == "kpi") {
      if (!this.kpiConfigLoaded) return false;
    }
    if (tab.tabId == "mng") {
      if (
        !this.clinicListLoaded ||
        !this.roleListLoaded ||
        !this.rxOptLoaded ||
        !this.techIssuesListLoaded ||
        !this.techniciansListLoaded
      )
        return false;
    }
    if (tab.tabId == "operation-reports") {
      if (!this.clinicListLoaded || !this.agentListLoaded) return false;
    }
    if (tab.tabId == "agent-tasks") {
      if (
        !this.taskStatusListLoaded ||
        !this.clinicListLoaded ||
        !this.agentListLoaded
      )
        return false;
    }

    return true;
  }

  navigate(tab: Tab) {
    if (!this.isEnabled(tab)) return false;

    // If we're already on a KPI route and clicking KPI again, do nothing
    if (tab.tabId === "kpi" && this.router.url.includes("/kpi")) {
      return false;
    }

    this.router.navigate([tab.link]);

    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: tab,
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: tab,
      })
    );

    this.closeMobileNav();
  }

  closeMobileNav() {
    this.store.dispatch(
      UI__TOGGLE_MOBILE_NAV({
        mobileNavOpen: false,
      })
    );
  }

  onCreateOrder() {
    this.closeMobileNav();

    if (this.authService.currentUser.clinic) {
      this.selectedClinic = this.authService.currentUser.clinic;
      this.createOrder();
    } else {
      this.selectClinicDisplay = true;
    }
  }

  createOrder() {
    this.broshService
      .createOrder(Number.parseInt(this.selectedClinic?.id))
      .subscribe(
        (data) => {
          let form = new RXForm();
          form.formId = data.formId;

          this.broshService.getOrderHeaderSingle(data.orderId).subscribe(
            (order) => {
              this.store.dispatch(
                SELECT_INBOX_ORDER({
                  order: order,
                })
              );

              this.store.dispatch(
                SELECT_RX_FORM({
                  form: form,
                })
              );

              if (this.router.url == "/main/inbox/order/rx") {
                this.router
                  .navigate([this.routeEnum.URL_DASHBOARD])
                  .then(() => {
                    this.store.dispatch(
                      SELECT_INBOX_ORDER({
                        order: order,
                      })
                    );

                    this.store.dispatch(
                      SELECT_RX_FORM({
                        form: form,
                      })
                    );
                    this.router.navigate([this.routeEnum.URL_ORDER_RX]);
                  });
              } else {
                this.router.navigate([this.routeEnum.URL_ORDER_RX]);
              }
            },
            (error) => {
              this.sharedService.alertError(error);
            }
          );
        },
        (err) => { }
      );
  }

  onClinicSelect() {
    this.selectClinicDisplay = false;
    this.createOrder();
  }
}
